import { useState, useEffect, useRef } from 'react'

type UseInViewProps = {
	threshold: number
}

const useIsInView = ({ threshold }: UseInViewProps): { ref: React.RefObject<HTMLDivElement>; inView: boolean } => {
	const [inView, setinView] = useState<boolean>(false)
	const ref = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const observer = new IntersectionObserver(([entry]) => setinView(entry.isIntersecting), {
			root: null,
			rootMargin: '0px',
			threshold,
		})

		if (ref.current) {
			observer.observe(ref.current)
		}

		return () => {
			if (ref.current) {
				// eslint-disable-next-line
				observer.unobserve(ref.current)
			}
		}
	}, [threshold])

	return { ref, inView }
}

export default useIsInView
